import { render, staticRenderFns } from "./MRegistration.vue?vue&type=template&id=feb235b6&"
import script from "./MRegistration.vue?vue&type=script&lang=js&"
export * from "./MRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports